// extracted by mini-css-extract-plugin
module.exports = {"buttons":"TranslateProductForm_buttons__2cdfs","input":"TranslateProductForm_input__iNq-d","label":"TranslateProductForm_label__2Wcdh"};